// extracted by css-extract-rspack-plugin
export default {"avatar":"TimelineAuthor-module__avatar__qfgC8"};